import React from 'react';
import { Pie, Bar } from 'react-chartjs-2';
import './Nutri.css';
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
} from 'chart.js';

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);


const NutrientPieChart = ({ totals }) => {
  const nutrientKeys = [
    { key: 'calories', label: 'Calories', unit: 'kcal' },
    { key: 'carbohydrates', label: 'Carbohydrates', unit: 'g' },
    { key: 'fat', label: 'Fat', unit: 'g' },
    { key: 'protein', label: 'Protein', unit: 'g' },
    { key: 'fiber', label: 'Fiber', unit: 'g' },
    { key: 'water', label: 'Water', unit: 'g' },
    { key: 'vitaminC', label: 'Vitamin C', unit: 'mg', source: 'vitamins' },
    { key: 'vitaminA', label: 'Vitamin A', unit: 'µg', source: 'vitamins' },
    { key: 'calcium', label: 'Calcium', unit: 'mg', source: 'minerals' },
    { key: 'iron', label: 'Iron', unit: 'mg', source: 'minerals' }
  ];

  // Filter nutrients that exist in totals (including nested vitamins/minerals)
  const availableNutrients = nutrientKeys.filter(({ key, source }) => {
    if (source && totals[source]) {
      return totals[source][key] !== undefined;
    }
    return totals[key] !== undefined;
  });

  const values = availableNutrients.map(({ key, source }) => {
    if (source && totals[source]) {
      return totals[source][key] || 0;
    }
    return totals[key] || 0;
  });

  const totalSum = values.reduce((acc, val) => acc + val, 0);
  const percentages = values.map(val => ((val / totalSum) * 100).toFixed(1));

  const data = {
    labels: availableNutrients.map((nutrient, i) => `${nutrient.label} (${percentages[i]}%)`),
    datasets: [{
      data: values,
      backgroundColor: [
        '#f4c430', '#ffe4b5', '#f08080', '#90ee90', '#dda0dd',
        '#87cefa', '#ffb347', '#ffcccb', '#add8e6', '#d2b48c'
      ].slice(0, values.length),
      borderColor: '#fff',
      borderWidth: 2
    }]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: '#333',
          font: {
            size: 14,
            family: 'Poppins'
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const nutrient = availableNutrients[context.dataIndex];
            const value = context.raw;
            const percent = ((value / totalSum) * 100).toFixed(1);
            return `${nutrient.label}: ${value.toFixed(2)} ${nutrient.unit} (${percent}%)`;
          }
        }
      },
      title: {
        display: true,
        text: 'Nutrient Distribution (%)',
        font: {
          size: 18,
          family: 'Poppins'
        },
        color: '#444'
      }
    }
  };

  
const barData = {
  labels: availableNutrients.map(n => n.label),
  datasets: [{
    label: 'Nutrient Values',
    data: values,
    backgroundColor: [
      '#f4c430', '#ffe4b5', '#f08080', '#90ee90', '#dda0dd',
      '#87cefa', '#ffb347', '#ffcccb', '#add8e6', '#d2b48c'
    ].slice(0, values.length),
    borderRadius: 6,
    barThickness: 30,
    maxBarThickness: 40
  }]
};

const barOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: function (context) {
          const nutrient = availableNutrients[context.dataIndex];
          const value = context.raw;
          return `${nutrient.label}: ${value.toFixed(2)} ${nutrient.unit}`;
        }
      }
    },
    title: {
      display: true,
      text: 'Nutrient Values',
      font: { size: 18, family: 'Poppins' },
      color: '#444'
    }
  },
  scales: {
    x: {
      ticks: {
        color: '#333',
        font: { family: 'Poppins', size: 12 }
      },
      grid: { display: false }
    },
    y: {
      ticks: {
        color: '#666',
        font: { family: 'Poppins', size: 12 }
      },
      grid: { color: '#eee' }
    }
  }
};


return (
  <div className="chart-wrapper">
    <div className="pie-chart-container">
      <Pie data={data} options={options} />
    </div>
    <div className="bar-chart-container">
      <Bar data={barData} options={barOptions} />
    </div>
    <div>
<img src="/Images/Nutrients.png"  width="400" height="auto" />


     </div>
  </div>
);

};

export default NutrientPieChart;
